// extracted by mini-css-extract-plugin
export var active = "menu-module--active--82ebf";
export var dot = "menu-module--dot--7540f";
export var link = "menu-module--link--a1c5d";
export var mobileNav = "menu-module--mobile-nav--1fcdd";
export var navList = "menu-module--nav-list--bab7f";